import { Background } from "./background/Background";
import { GameVars } from "../GameVars";
import { GameConstants } from "../GameConstants";
import { AudioManager } from "../managers/AudioManager";
import { Game } from "../Game";
import { GameManager } from "../managers/GameManager";
import { Translation } from "../Translation";

export class PreloadScene extends Phaser.Scene {

    public static currentInstance: PreloadScene;

    private progressBar: Phaser.GameObjects.Graphics;

    constructor() {

        super("PreloadScene");

        PreloadScene.currentInstance = this;
    }

    public preload(): void {

        GameVars.currentScene = this;

        this.composeScene();
        this.loadAssets();
    }

    public create(): void {
        Translation.init(this.cache.json.get("game_texts"));
        this.loadHowl();
    }

    public loadAssets(): void {

        this.load.atlas("texture_atlas_0", "assets/textures/texture_atlas_0.png", "assets/textures/texture_atlas_0.json");
        this.load.atlas("texture_atlas_1", "assets/textures/texture_atlas_1.png", "assets/textures/texture_atlas_1.json");
        this.load.atlas("texture_atlas_2", "assets/textures/texture_atlas_2.png", "assets/textures/texture_atlas_2.json");

        this.load.json("audiosprite", "assets/audio/audiosprite.json");
        this.load.json("bots", "assets/bots/bots.json");
        this.load.json("game_texts", "assets/texts/game_texts.json");
        this.load.image("ca_logo", "assets/ca_logo.png");

        (this.load as any).spine("burger-teen", "assets/spine/burger-teen.json", "assets/spine/burger-teen.atlas");
        (this.load as any).spine("demon", "assets/spine/demon.json", "assets/spine/demon.atlas");
        (this.load as any).spine("moai", "assets/spine/moai.json", "assets/spine/moai.atlas");
        (this.load as any).spine("monkey", "assets/spine/monkey.json", "assets/spine/monkey.atlas");
        (this.load as any).spine("richMan", "assets/spine/richMan.json", "assets/spine/richMan.atlas");
        (this.load as any).spine("sloth", "assets/spine/sloth.json", "assets/spine/sloth.atlas");
        (this.load as any).spine("zombie", "assets/spine/zombie.json", "assets/spine/zombie.atlas");
        (this.load as any).spine("bananaExp", "assets/spine/bananaExp.json", "assets/spine/bananaExp.atlas");

        this.load.on("progress", this.updateLoadedPercentage, this);
    }

    private updateLoadedPercentage(percentageLoaded: number): void {

        // los valores del porcentaje cargado disminuyen por algun bug
        if (this.progressBar.scaleX < percentageLoaded) {
            this.progressBar.scaleX = percentageLoaded;
        }
    }

    private composeScene(): void {

        const background = new Background(this);
        this.add.existing(background);

        this.progressBar = this.add.graphics();
        this.progressBar.fillStyle(0xFFD300);
        this.progressBar.fillRect(0, GameConstants.GAME_HEIGHT - 6, GameConstants.GAME_WIDTH, 6);
        this.progressBar.scaleX = 0;
    }

    private loadHowl(): void {

        let json = this.cache.json.get("audiosprite");
        json = JSON.parse(JSON.stringify(json).replace("urls", "src"));

        AudioManager.sound = new Howl(json);

        AudioManager.sound.on("load", function (): void {

            const w = window.innerWidth;
            const h = window.innerHeight;

            if (Game.currentInstance.device.os.desktop || h < w) {
                GameManager.onGameAssetsLoaded();
                PreloadScene.currentInstance.scene.setVisible(false);
                GameVars.gameLoaded = true;
            } else {
                document.getElementById("orientation").style.display = "block";
                document.getElementById("content").style.display = "none";
            }
        });
    }
}
